import CustomerPostSanctionDocs from "../../../jsx/components/Dashboard/CustomerPostSanctionDocs/CustomerPostSanctionDocs";

const CustomerPostSanctionDocsWrapper = () => {
  return <CustomerPostSanctionDocs />;
};

export default constore(CustomerPostSanctionDocsWrapper);
